module.exports = __webpack_public_path__ + "img/cb_K.d01cdc77.svg";